export default "__VITE_ASSET__eb9ae60f__"